// extracted by mini-css-extract-plugin
module.exports = {"applePay":"CheckoutApplePay__applePay___ErKeO","consent":"CheckoutApplePay__consent___12tKR"};